
import { Component } from 'vue-property-decorator'
import BaseLayout from '@/shared/components/BaseLayout.vue'
import { Action, Getter } from 'vuex-class'
import Settings from '@/api/models/Settings'
import { baseSettings } from '../formData'
import PriceLink from '@/modules/settings/components/PriceLink.vue'
import StorageMixin from '@/shared/mixins/StorageMixin.vue'
import NotificationKey from '@/modules/settings/components/NotificationKey.vue'

@Component({
    components: {
        NotificationKey,
        PriceLink,
        BaseLayout
    },
    mixins: [StorageMixin]
})

export default class SettingsBase extends BaseLayout {
    private readonly STATE = {
        DEFAULT: 'default',
        LOADING: 'loading'
    }

    @Getter('settings')
    settings!: Settings

    @Action('loadSettingsBase')
    loadSettingsBase!: () => Promise<void>

    @Action('saveSettings')
    saveSettings!: (settings: Settings) => Promise<void>

    private formSettings: Settings = {}

    private form = baseSettings

    private loadAnimate = this.STATE.DEFAULT

    private errors: { [key: string]: string } = {}

    async created (): Promise<void> {
        await this.handleCallback(async () => {
            await this.loadSettingsBase()
        })
        this.formSettings = this.settings
    }

    private async save (): Promise<void> {
        this.validateBusiness()
        if (!Object.keys(this.errors).length) {
            this.loadAnimate = this.STATE.LOADING
            // при сохранении не передаем даты
            delete this.formSettings.priceUpdatedAt
            delete this.formSettings.sinceUpdatedAt

            await (this.$refs.baseLayout as BaseLayout).handleWithAlerts(async () => {
                await this.saveSettings(this.formSettings)
                this.formSettings = this.settings
            }, this.$t('settings.success'))

            this.loadAnimate = this.STATE.DEFAULT
        }
    }

    private validateBusiness (): void {
        this.errors = {}
        if (this.formSettings.businessId === '') {
            this.formSettings.businessId = null
        }

        if (
            this.formSettings.businessId !== undefined &&
            this.formSettings.businessId !== null &&
            !(/^[0-9]*$/.test(this.formSettings.businessId))
        ) {
            this.errors.businessId = this.$t('settings.errors.businessId').toString()
        }
    }
}
